import type { ColDef } from "~/components/grid/AgGrid";
import type { AnswerLayoutRow } from "~/helpers/aiChat/answerLayouts";
import type { AnswerColumnResult } from "~/services/aiOrchestrator";

import answerLayouts from "~/helpers/aiChat/answerLayouts";

const answerLayoutColumns = (columns: readonly AnswerColumnResult[]): ColDef<AnswerLayoutRow>[] =>
	columns.map(({ label, type }, index) => ({
		colId: `column${index}`,
		comparator: (a: string, b: string) => answerLayouts.compareCells(type, a, b),
		filter: false,
		headerName: label,
		minWidth: 100,
		type: type === "NUMBER" ? "rightAligned" : undefined,
		valueFormatter: ({ value }) => answerLayouts.formatCell(type, value ?? ""),
		valueGetter: ({ data }) => data?.cells[index] ?? ""
	}));

export default answerLayoutColumns;
